import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Brush,
  ReferenceLine,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import "../styles/components/rpt-chart.scss";

const RPTChart = ({ data }) => {
  return (
    <div className="rpt-chart">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          stackOffset="sign"
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            // tick={{
            //   angle: 75,
            //   textAnchor: "start",
            //   dominantBaseline: "ideographic",
            // }}
          />
          <YAxis />
          <Tooltip cursor={{ fill: "rgba(0,0,0,.1)" }} />
          <Legend verticalAlign="top" wrapperStyle={{ lineHeight: "40px" }} />
          <ReferenceLine y={0} stroke="#000" />
          <Brush dataKey="time" height={50} stroke="#8884d8" fill="transparent">
            <BarChart>
              <Bar dataKey="phase_connect" fill="#66bcef" stackId="stack" />
              <Bar dataKey="phase_resolve" fill="#ffaeae" stackId="stack" />
              <Bar dataKey="phase_tls" fill="#f5f5f5" stackId="stack" />
              <Bar dataKey="phase_transfer" fill="#9ad5a4" stackId="stack" />
            </BarChart>
          </Brush>
          <Bar dataKey="phase_connect" fill="#66bcef" stackId="stack" />
          <Bar dataKey="phase_resolve" fill="#ffaeae" stackId="stack" />
          <Bar dataKey="phase_tls" fill="#f5f5f5" stackId="stack" />
          <Bar dataKey="phase_transfer" fill="#9ad5a4" stackId="stack" />
          {/* <Line
            type="monotone"
            dataKey="probe_duration_seconds"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          /> */}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RPTChart;
